import axios from "axios";

export class ServiceId06Controller {
  async checkId06(orgNumber) {
    const response = await axios.get("/api/id06", {
        params: {company_registration_number: orgNumber}
    });
    return response;
  }
}

export const ServiceId06 = new ServiceId06Controller();
